import cn from 'classnames';

import {sizeClass} from '../../shared/classNames';

import type {ButtonRootOptions, ButtonShape, ButtonType} from './types';

import styles from './styles.module.scss';

/** Plain lookups rather than `cva`: smaller, and they need no second vocabulary. */
const TYPE_CLASS: Record<ButtonType, string> = {
  primary: styles.button__typePrimary,
  secondary: styles.button__typeSecondary,
  link: styles.button__typeLink,
};

const SHAPE_CLASS: Record<ButtonShape, string> = {
  standard: '',
  square: styles.button__modSquare,
};

/**
 * The root's data attributes and classes, identical whichever element `as`
 * renders, so the three branches in `Button` only differ in the element.
 */
export const buttonRootProps = ({
  look,
  shape,
  danger,
  size,
  loading,
  ariaDisabled,
  fullWidth,
  className,
}: ButtonRootOptions) => ({
  'data-slot': 'button',
  'data-type': look,
  'data-shape': shape,
  'data-danger': danger || undefined,
  'data-size': size,
  'data-loading': loading || undefined,
  'aria-busy': loading || undefined,
  'aria-disabled': ariaDisabled || undefined,
  className: cn(
    styles.button,
    TYPE_CLASS[look],
    sizeClass(styles, 'button', size),
    SHAPE_CLASS[shape],
    danger && styles.button__modDanger,
    fullWidth && styles.button__modFullWidth,
    className,
  ),
});
